import { AlbumState } from '@/data/models/albumState';
import {
  isAlbumReadOnlyStates,
  isEditableAlbumReadOnlyState,
} from '@/components/common/ProductUtilities';

export enum ProductViewModes {
  Edit = 'Edit',
  ReadOnly = 'ReadOnly',
  Disabled = 'Disabled',
  ChangeRequest = 'ChangeRequest',
  ChangeRequestReadOnly = 'ChangeRequest ReadOnly',
}

export const getProductViewMode = (
  albumState: AlbumState,
  canUserEditProduct: boolean
) => {
  const isEditableReadOnlyProductState =
    isEditableAlbumReadOnlyState(albumState);
  if (isEditableReadOnlyProductState && canUserEditProduct) {
    return ProductViewModes.Edit;
  }
  const isReadOnlyProductState = isAlbumReadOnlyStates(albumState);
  if (!canUserEditProduct || isReadOnlyProductState) {
    return ProductViewModes.ReadOnly;
  }
  return ProductViewModes.Edit;
};

export const isProductEditMode = (productMode: ProductViewModes) => {
  return productMode === ProductViewModes.Edit;
};

export const isProductReadOnlyMode = (productMode: ProductViewModes) => {
  return productMode === ProductViewModes.ReadOnly;
};

export const allowsIdentifierAssignment = (albumState?: AlbumState) => {
  return albumState === AlbumState.Draft || albumState === AlbumState.Rejected;
};
